module.exports = __webpack_public_path__ + "img/clock.71b2fd82.svg";